export const REDUCER_NAME = 'USER'

